import { FC } from "react";
import { Modal } from "react-bootstrap";
import { TaskTimeEntry } from "app/reducers/task/taskDataInterface";
import { convert } from "app/helpers/helperFunction";

interface TimeDetailsModalProps {
  show: boolean;
  onHide: () => void;
  timeEntry: TaskTimeEntry;
}

const TimeDetailsModal: FC<TimeDetailsModalProps> = ({ show, onHide, timeEntry }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="time-details-modal"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Time Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th className="fw-bold">Assignee Name</th>
                <th className="fw-bold">Date</th>
                <th className="fw-bold">Hours Worked</th>
              </tr>
            </thead>
            <tbody>
              {timeEntry.TimeDetails.map((detail, index) => (
                <tr key={index}>
                  <td>{detail.AssigneeName}</td>
                  <td>{convert(detail.Date)}</td>
                  <td>{detail.HoursWorked}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TimeDetailsModal; 